import { CallRequestType } from '../customer-call-sdk/types/call';
import { MeetingCallType, MeetingDetails } from '../types/meeting-details';

export const DU_MEETING_HANDOFF_ATTEMPT = 'duMeetingHandoffAttempt';

const ZERO_WIDTH = new RegExp('[\u200B-\u200D\u2060\uFEFF]', 'g');
const UNICODE_DASH = new RegExp('[\u2010-\u2015\u2043\u2212\uFE58\uFE63\uFF0D]', 'g');
const UNICODE_SPACE = new RegExp('[\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]', 'g');

function foldForMatching(text: string): string {
    return text
        .replace(ZERO_WIDTH, '')
        .replace(UNICODE_DASH, '-')
        .replace(UNICODE_SPACE, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

const SCHEME_URL = /(?:https?:\/\/|www\.)\S+/i;

const BARE_HOST_WITH_PATH = /\b[a-z0-9][a-z0-9-]*(?:\.[a-z0-9][a-z0-9-]*)*\.[a-z]{2,}[/?]\S*/i;

const DIGIT_RUN = /\d(?:[ .-]*\d){8,}/;

const GOOGLE_MEET_CODE = /(?:^|[^a-z0-9-])[a-z]{3}-[a-z]{4}-[a-z]{3}(?![a-z0-9-])/i;

const PLATFORM_KEYWORD =
    /\b(?:microsoft teams|ms teams|google meet|gmeet|hangouts?|webex|teams|zoom|meet)\b/i;

const PASSCODE_SIGNAL =
    /\b(?:meeting password|security code|pass ?code|password|pwd|pin|code|key)\b.{0,20}?[A-Za-z0-9._%-]{4,12}/i;

export function isPotentialMeetingMessage(text: string): boolean {
    const candidate = foldForMatching(text ?? '');

    return (
        SCHEME_URL.test(candidate) ||
        BARE_HOST_WITH_PATH.test(candidate) ||
        DIGIT_RUN.test(candidate) ||
        GOOGLE_MEET_CODE.test(candidate) ||
        PLATFORM_KEYWORD.test(candidate)
    );
}

export function hasPasscodeSignal(text: string): boolean {
    return PASSCODE_SIGNAL.test(foldForMatching(text ?? ''));
}

export function buildPendoEventData(details: MeetingDetails): Record<string, unknown> {
    const { requestId, callType, sent, providerType, outcome, confidence, attemptIndex } = details;

    return {
        requestId,
        callType,
        sent,
        provider: providerType,
        attemptIndex,
        ...(sent === 'url' && callType === 'vri' && outcome ? { outcome } : {}),
        ...(sent === 'meeting_id' && confidence ? { confidence } : {}),
    };
}

export function toHandoffCallType(
    requestType: CallRequestType | null | undefined,
): MeetingCallType | null {
    if (requestType === 'VRI') {
        return 'vri';
    }
    if (requestType === 'VRS_INBOUND' || requestType === 'VRS_OUTBOUND') {
        return 'vrs';
    }
    return null;
}
